import clsx from 'clsx';
import type { DetailedHTMLProps, HTMLAttributes } from 'react';
import { type ButtonRenderProps } from 'react-aria-components';

import { ButtonContent } from './Button.blocks';
import type { Props as ButtonProps } from './Button.types';
import { DEFAULT_COLOR, DEFAULT_SIZE, DEFAULT_VARIANT } from './Button.constants';
import styles from './Buttons.module.css';

export type Props = Partial<Pick<ButtonRenderProps, 'isDisabled' | 'isHovered' | 'isFocusVisible'>> &
  DetailedHTMLProps<HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> &
  ButtonProps;

export function StaticButton({
  variant = DEFAULT_VARIANT,
  color = DEFAULT_COLOR,
  size = DEFAULT_SIZE,
  startIcon,
  endIcon,
  children,
  isDisabled,
  isHovered,
  isFocusVisible,
  isContentVisuallyHidden,
  ...rest
}: Props) {
  return (
    <span
      {...rest}
      data-hovered={isHovered ? 'true' : undefined}
      data-disabled={isDisabled ? 'true' : undefined}
      data-focus-visible={isFocusVisible ? 'true' : undefined}
      className={clsx(styles.root, styles[variant], styles[size], styles[color])}
    >
      <ButtonContent
        startIcon={startIcon}
        endIcon={endIcon}
        variant={variant}
        color={color}
        isDisabled={isDisabled}
        isContentVisuallyHidden={isContentVisuallyHidden}
      >
        {children}
      </ButtonContent>
    </span>
  );
}
